import React, { useState, useEffect } from "react";
import "../Assests/Scss/Dashboard.scss";
import axios from "axios";
import { format } from "date-fns";
import Welcome from "../Assests/Images/Cimages/Welcome.webp";
import Ptrends from "../Assests/Images/Ptrends.png";
import LookAnswer from "../Assests/Images/LookAnswer.png";
import Practice from "../Assests/Images/Practice.png";
import Performance from "../Assests/Images/Performance.png";
import Analyze from "../Assests/Images/Analyze.png";
import Rewards from "../Assests/Images/Rewards.png";
import Assessment from "../Assests/Images/Assessment.png";
// import FeedbackIocn from "../Assests/Images/FeedbackIocn.png";
import InternetChecking from "../Reusablecomponents/Network";
import CopyRight from "../Reusablecomponents/Copyright";
import { useNavigate } from "react-router-dom";
import { AssessmentName } from "../Reusablecomponents/RegularFunctions";
import { useSelector } from "react-redux";
import WithTranslate from "../../ReusableComponents/StaticTranslater/Translater";
import UpdateDetails from "./UpdateDetails";
import axiosInstance from "../../ReusableComponents/Axios";
import { GrHelpBook } from "react-icons/gr";
// import { FaHireAHelper } from "react-icons/fa6";
import { IoMdCloseCircleOutline } from "react-icons/io";
import notify from "../../ReusableComponents/ToastifyAlerts";

const Dashboard = () => {
  const navigate = useNavigate();

  const items = useSelector((state) => state.userDetailsData.LoginDetails);
  const [Assessments, SetAssessments] = useState();
  const [Notice, SetNotice] = useState();
  const [EnableButton, HideButton] = useState(false);
  const [Message, SetMessage] = useState();
  const [OpenPT, SetOpenPT] = useState(false);

  const [OpenUpdateSection, CloseUpdateSction] = useState(
    items.section === "X" || (items.electiveSubjectId === 0 && items.grade > 10) 
    || (items.studentLanguageId === 0 && items.grade <=10 && (items.instituteId == 5 ||items.instituteId == 8))
      ? true
      : false
  );
  const fetchAssessmentData = async () => {
    await axios
      .get(
        process.env.REACT_APP_API_BASE_URL +
        `/assessment/GetStudentAssessmentDetails?AssessmentType=0&UserId=${items.userId}&Grade=${items.grade}`,
        { headers: { XApiKey: process.env.REACT_APP_XApiKey } }
      )
      .then((res) => {
        if (res.data?.examStartDateTime) {
          SetAssessments(res.data);
          localStorage.setItem("AssessmentData", JSON.stringify(res.data));
          // if (res.data?.assessmentType === 3 && items?.grade <= 10) {
            const data = {
              Subjects: res.data.allSubjectNames.split(",").map((item) => item.trim()),
            };
            localStorage.setItem("SUbjectData", JSON.stringify(data));
          // }
          //Calculate time difference based on server time to display the timer if diff <= 15 min
          if (
            new Date(
              new Date(res?.data?.serverDate?.split(".")[0]).getTime() + 1000
            ) >= new Date(res.data.examStartDateTime)
          ) {
            // HideButton(!EnableButton);
            HideButton(true);
          } else {
            let sampleminutes =
              (new Date(res.data.examStartDateTime) -
                new Date(new Date(res?.data?.serverDate?.split(".")[0]))) /
              1000;
            if (sampleminutes <= 900) {
              const interval = setInterval(() => {
                if (sampleminutes > 0) {
                  SetMessage(
                    ` Assessment will start in ${formatTime(
                      sampleminutes
                    )} minute(s)`
                  );
                  sampleminutes = sampleminutes - 1;
                } else {
                  HideButton(true);
                  // HideButton(!EnableButton);
                  clearInterval(interval);
                }
              }, 1000);

              return () => clearInterval(interval);
            }
          }
        } else {
          SetAssessments();
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchAssessmentData();
    GetNotice();
  }, []);

  const PReport = (e, Pagetype) => {
    // if (
    //   new Date(Assessments?.examEndDateTime) >
    //   new Date(Assessments?.serverDate?.split(".")[0])
    // ) {
    //   alert(process.env.REACT_APP_INPROGRESSASSESSMENT);
    // } else {
      switch (e) {
        case "1":
          navigate("/PerformanceTrends");
          break;
        case "2":
          navigate("/ViewAnswerSheetDetails", { state: { Page: Pagetype } });
          break;
        case "3":
          navigate("/LoPerformanceReport");
          break;
        // case "4":
        //   navigate("/Feedback");
        //   break;
        case "5":
          navigate("/AssessmentBadges");
          break;
        default:
          navigate("/LoPerformanceReport");
          break;
      }
    // }
  };
  const AssessmentLink = () => {
    if (Assessments && Assessments?.isSubmitted !== 1 && EnableButton && (Assessments?.isQPAvailable || items?.grade <= 10)) {
      navigate("/Student/Assessment");
    } else if (Assessments?.isSubmitted === 1) {
      alert(process.env.REACT_APP_INPROGRESSASSESSMENT);
    } else if (!EnableButton) {
      notify(
        "You can attempt the assessment only at the Scheduled time",
        "error"
      );
    }
  };

  const titleRender =""
    // new Date(Assessments?.examEndDateTime) > new Date() &&
    // "This is not accessible as the assessment is in progress.";
  const GetNotice = async () => {
    try {
      const response = await axiosInstance.get(
        `/Assessment/GetLatestAssessmentDetails?UserId=${items.userId}`
      );
      if (response.data[0].examAvailabilityStartDate) {

        SetNotice(response.data.filter((test) => test.isAssessmentCompleted === 0));
      } else {
        SetNotice();
      }
    } catch (error) {
      console.error(error);
    }
  };

  // Start: To Format the Time as per the display format in the timer
  const formatTime = (seconds) => {
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor((seconds % 3600) / 60);
    const secs = seconds % 60;
    if (hours > 0) {
      let Rtime = `${String(hours).padStart(2, "0")}:${String(minutes).padStart(
        2,
        "0"
      )}:${String(secs).padStart(2, "0")}`;
      return Rtime;
    } else {
      let Rtime = `${String(minutes).padStart(2, "0")}:${String(secs).padStart(
        2,
        "0"
      )}`;
      return Rtime;
    }
  };

  // End: To Format the Time as per the display format in the timer

  return (
    <>
      <div className="Dashboard-Maindiv Instructions-pages">
        {!OpenUpdateSection ? (
          <>
            <InternetChecking />
            <div className="Welcome dflex alignitems">
              <img src={Welcome} alt="Welcome image" />
              <div className="Welcome-Details">
                <span>
                  {(Assessments?.isQPAvailable || items?.grade <= 10 || !Assessments) ? AssessmentName(Assessments?.assessmentType) ||
                    "No Assessment scheduled" :
                     <div className=" BlinkingText"
                            style={{ color: "#082777", alignSelf: "flex-end" }}
                          >
                            <b>
                              No Active Assessment for {Assessments?.electiveSubject} as an elective subject student
                               </b>
                          </div>
                   }
                </span>

                {(Assessments?.isQPAvailable || items?.grade <= 10) ? <>

                  {Assessments?.isSubmitted !== 1 ? (
                    <>
                      {Assessments?.examStartDateTime ? (
                        <>
                          <div>
                            {" "}
                            {format(
                              new Date(Assessments?.examStartDateTime),
                              "do MMMM yyyy hh:mm a"
                            )}{" "}
                            to{" "}
                            {format(
                              new Date(Assessments?.examEndDateTime),
                              "do MMMM yyyy hh:mm a"
                            )}
                          </div>
                        </>
                      ) : (
                        <div>{Assessments}</div>
                      )}
                      {Assessments?.examStartDateTime && EnableButton ? (
                        (Assessments?.isQPAvailable || items?.grade <= 10) ?
                          (
                            <button className="Buttons" onClick={AssessmentLink}>
                              Begin Assessment
                            </button>)
                          :
                          <div
                            className=" BlinkingText"
                            style={{ color: "#082777", alignSelf: "flex-end" }}
                          >
                            {" "}
                            <b> The Question paper for {Assessments?.electiveSubject} is not avaliable please contact your administrator </b>
                          </div>

                      ) : (
                        <div
                          className=" BlinkingText"
                          style={{ color: "#082777", alignSelf: "flex-end" }}
                        >
                          {" "}
                          <b> {Message}</b>
                        </div>
                      )}
                    </>
                  ) : (
                    <div>
                      {new Date(Assessments?.examEndDateTime) > new Date() &&
                        process.env.REACT_APP_INPROGRESSASSESSMENT}
                    </div>
                  )}</> : ""}
              </div>
            </div>

            <div>
              <div className=" dflex alignitems JSBetween DHeading">
                <h3>
                  <span style={{ textTransform: "capitalize" }}>
                    Hi,{items.fullName?.toLowerCase()}
                  </span>{" "}
                  <WithTranslate name="Dashboard.Question" />
                </h3>
                <div className="Help" onClick={() => SetOpenPT(!OpenPT)}>
                  <GrHelpBook />
                  <b>Help</b>
                </div>
              </div>

              <div className="Udetails dflex">
                <div
                  className={`dflex UOptions ${new Date(Assessments?.examEndDateTime) > new Date() &&
                    "Disabled"
                    }`}
                >
                  <div onClick={() => PReport("1")} title={titleRender}>
                    {" "}
                    <WithTranslate name="Dashboard.Card1" />
                    <img src={Ptrends} alt="Ptrends" />
                  </div>

                  <div
                    className={
                      Assessments
                        ? Assessments?.isSubmitted !== 1 && (Assessments?.isQPAvailable || items?.grade <= 10)
                          ? "BlinkingText"
                          : "DisableTest"
                        : "DisableTest"
                    }
                    onClick={AssessmentLink}
                    title={
                      Assessments && Assessments?.isSubmitted !== 1
                        ? ""
                        : new Date(Assessments?.examEndDateTime) > new Date()
                          ? "You have already taken the assessment. Please check your results"
                          : process.env.REACT_APP_NOASSESSMENT
                    }
                  >
                    <WithTranslate name="Dashboard.Card2" />{" "}
                    <img src={Assessment} alt="Assessment" />
                  </div>

                  <div
                    onClick={() => PReport("2", "ANswerSheet")}
                    title={titleRender}
                  >
                    <WithTranslate name="Dashboard.Card3" />
                    <img src={LookAnswer} alt="LookAnswer" />
                  </div>
                  {/* <div title={titleRender}>
                    <WithTranslate name="Dashboard.Card4" />
                    <img src={Practice} alt="Practice" />
                  </div> */}
                  <div onClick={() => PReport("2", "LOPR")} title={titleRender}>
                    <WithTranslate name="Dashboard.Card5" />
                    <img src={Analyze} alt="Analyze" />
                  </div>
                  <div onClick={() => PReport("2", "LOPR")} title={titleRender}>
                    <WithTranslate name="Dashboard.Card6" />
                    <img src={Performance} alt="Performance" />
                  </div>
                  {/* <div onClick={() => PReport("4")} title={titleRender}>
                    <WithTranslate name="Dashboard.Card7" />
                    <img src={FeedbackIocn} alt="Performance" />
                  </div> */}
                  <div title={titleRender} onClick={() => PReport("5")}>
                    <WithTranslate name="Dashboard.Card8" />
                    <img src={Rewards} alt="Rewards" />
                  </div>
                </div>
                {/* && Assessments?.isSubmitted === 1 */}
                <div className="Notice">
                  <h5>Notice</h5>
                  <div>
                    <b>Assessment Schedule</b>
                    <br />
                    {Notice?.length > 0 ? (
                      <ol>
                        {Notice?.map((item) => (
                          <li className="mb-3">
                            Upcoming {item.assessmentTypeNo} assessment schedule
                            on {item.examAvailabilityStartDate} to{" "}
                            {item.examAvailabilityEndDate}
                          </li>
                        ))}
                      </ol>
                    ) : (
                      "No Assessments are available"
                    )}
                  </div>
                </div>
              </div>
              <CopyRight />
            </div>
          </>
        ) : (
          <>
            <UpdateDetails
              ChangeType={CloseUpdateSction}
              Updatedata={fetchAssessmentData}
            />
          </>
        )}
        {OpenPT && (
          <div className=" Model-Open">
            <div className="Card w-100 h-100">
              <div className="dflex JSBetween">
                <div></div>
                <div className="CPointer fs-4">
                  <IoMdCloseCircleOutline onClick={() => SetOpenPT(!OpenPT)} />
                </div>
              </div>
              <iframe
                src="/Portal Tutorial.pdf"
                width="100%"
                height="95%"
                title="PDF Viewer"
              ></iframe>
            </div>
          </div>
        )}
      </div>
    </>
  );
};
export default Dashboard;